import React, { useState } from "react";
import "../Style.css";

const CtoPopupForm = ({ onClose, isClosing }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    projectDescription: "",
  });

  const [submitMessage, setSubmitMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setSubmitMessage("");

    try {
      const response = await fetch("https://www.hatchcoders.com/submit.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSubmitMessage("Your request was submitted successfully!");
        setFormData({
          fullName: "",
          email: "",
          phoneNumber: "",
          projectDescription: "",
        });
        setTimeout(() => {
          onClose();
          setSubmitMessage("");
        }, 2000);
      } else {
        setSubmitMessage(result.message || "Failed to submit.");
      }
    } catch (error) {
      console.error("Error:", error);
      setSubmitMessage("An error occurred. Please try again.");
    }

    setSubmitting(false);
  };

  return (
    <div className={`cto-popup-form ${isClosing ? "slide-out" : ""}`}>
      <button onClick={onClose} className="close-btn1">
        <img src="../Images/close-white.svg" alt="Close" />
      </button>
      <h3>
        Let’s Build Your Idea <span className="highlight">Together</span>
      </h3>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="fullName"
          placeholder="Full Name"
          value={formData.fullName}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Business Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="tel"
          name="phoneNumber"
          placeholder="Mobile Number"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
        />
        <textarea
          name="projectDescription"
          placeholder="Please Share Your Business Requirements"
          value={formData.projectDescription}
          onChange={handleChange}
          rows={4}
        />
        <button type="submit" disabled={submitting}>
          {submitting ? "Sending..." : "Call Me Now"}
        </button>
      </form>
      {submitMessage && <p className="submit-message">{submitMessage}</p>}
    </div>
  );
};

export default CtoPopupForm;
